const collections = [
  {
    no: "01",
    title: "影视 · 新剧雷达",
    desc: "热剧定档、上线与口碑追踪，一份把好看剧综提前圈好的追番手册。",
    img: "https://readdy.ai/api/search-image?query=cinema%20seat%20view%20toward%20a%20softly%20lit%20movie%20screen%20with%20warm%20red%20velvet%20curtains%20and%20popcorn%2C%20atmospheric%20cinematic%20warm%20tones%2C%20muted%20ink%20palette%2C%20editorial%20still%20life%2C%20soft%20natural%20lighting&width=900&height=700&seq=chigua-cine-x1&orientation=portrait",
    tag: "8.2k 在看",
  },
  {
    no: "02",
    title: "娱乐 · 现场回声",
    desc: "演唱会和台前幕后的观察笔记，收好每一份值得奔赴的现场攻略。",
    img: "https://readdy.ai/api/search-image?query=concert%20stadium%20silhouette%20with%20sparkling%20warm%20amber%20and%20red%20stage%20lights%20against%20cream%20sky%2C%20crowd%20hands%20raised%2C%20dreamy%20editorial%20concert%20poster%20mood%2C%20soft%20grainy%20warm%20tones&width=900&height=700&seq=chigua-live-x1&orientation=portrait",
    tag: "5.4k 在看",
  },
  {
    no: "03",
    title: "财经 · 商业切片",
    desc: "热点公司的来龙去脉，把商业大事讲成能一口气读懂的故事。",
    img: "https://readdy.ai/api/search-image?query=minimal%20editorial%20arrangement%20of%20newspaper%20finance%20pages%20with%20rising%20line%20charts%2C%20a%20calculator%20and%20golden%20paperclips%20on%20cream%20paper%2C%20warm%20neutral%20desk%20lighting%2C%20premium%20print%20editorial%20aesthetic&width=900&height=700&seq=chigua-biz-x1&orientation=portrait",
    tag: "6.1k 在看",
  },
  {
    no: "04",
    title: "科技 · 新事速写",
    desc: "新发布与行业风向的轻解读，五分钟知道圈内今天在聊什么。",
    img: "https://readdy.ai/api/search-image?query=editorial%20still%20of%20modern%20gadgets%20and%20circuit%20detail%20on%20a%20warm%20cream%20desk%2C%20soft%20muted%20amber%20and%20olive%20tones%2C%20premium%20tech%20magazine%20cover%20photography%2C%20gentle%20soft%20shadows&width=900&height=700&seq=chigua-tech-x1&orientation=portrait",
    tag: "3.9k 在看",
  },
  {
    no: "05",
    title: "社会 · 万象记事",
    desc: "城市与人的真实切片，克制记录正在发生的人间百态。",
    img: "https://readdy.ai/api/search-image?query=quiet%20city%20street%20at%20golden%20hour%20seen%20through%20a%20window%20with%20reflections%2C%20pedestrians%20as%20soft%20blur%2C%20warm%20cream%20and%20brown%20tones%2C%20editorial%20documentary%20photography%2C%20peaceful%20cinematic%20mood&width=900&height=700&seq=chigua-city-x1&orientation=portrait",
    tag: "4.7k 在看",
  },
  {
    no: "06",
    title: "人物 · 访谈侧记",
    desc: "创业者与创作者的短访谈，听他们把选择背后的理由讲明白。",
    img: "https://readdy.ai/api/search-image?query=portrait%20interview%20setup%20with%20warm%20vintage%20armchair%20and%20round%20table%20with%20two%20cups%20of%20tea%2C%20a%20recorder%2C%20soft%20window%20light%20on%20cream%20wall%2C%20editorial%20profile%20feature%20photography%2C%20muted%20earthy%20tones&width=900&height=700&seq=chigua-person-x1&orientation=portrait",
    tag: "3.2k 在看",
  },
];

export default function Collection() {
  return (
    <section id="collection" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        {/* section head */}
        <div className="flex flex-col gap-2 border-b border-foreground-200 pb-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-semibold tracking-[0.3em] text-primary-600">
              COLUMNS & COLLECTIONS
            </span>
            <h2 className="mt-2 font-heading text-3xl font-bold text-foreground-950 md:text-4xl">
              栏目合集
            </h2>
          </div>
          <p className="max-w-md text-sm leading-relaxed text-foreground-600 md:text-right">
            六个常设栏目，从影视到人物。想一次看全吃瓜官网的内容版图，
            从这里按图索骥即可。
          </p>
        </div>

        {/* big image card grid */}
        <div className="mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {collections.map((c) => (
            <article
              key={c.no}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors hover:border-primary-200"
            >
              <div className="relative h-52 w-full overflow-hidden">
                <img
                  src={c.img}
                  alt={`吃瓜官网栏目合集 ${c.title}`}
                  title={`吃瓜官网 ${c.title}`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded bg-background-50/90 px-2 py-1 text-[11px] font-semibold text-primary-700">
                  <i className="ri-fire-line mr-0.5"></i>
                  {c.tag}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <div className="flex items-baseline gap-3">
                  <span className="font-heading text-2xl font-bold text-secondary-400">
                    {c.no}
                  </span>
                  <h3 className="font-heading text-lg font-bold text-foreground-950 group-hover:text-primary-600">
                    {c.title}
                  </h3>
                </div>
                <p className="mt-3 flex-1 text-sm leading-relaxed text-foreground-600">
                  {c.desc}
                </p>
                <div className="mt-5 flex items-center justify-between border-t border-background-200 pt-3">
                  <span className="text-xs text-foreground-400">进入栏目</span>
                  <span className="flex h-7 w-7 items-center justify-center rounded-full bg-secondary-100 text-secondary-800 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                    <i className="ri-arrow-right-line text-sm"></i>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}